/* YCOO : comportement des cartes produit (snippets/product-card.liquid), chargé une seule fois dans layout/theme.liquid.
   La fonction de défilement window.__ycooSlide est définie dans layout/theme.liquid. */
(function() {

  // Textes traduits (window.ycooStrings, layout/theme.liquid) ; valeurs françaises si la page ne les fournit pas
  var t = window.ycooStrings || { size: 'Taille', close: 'Fermer', sizeGuide: 'Guide des tailles' };

  // Ajoute une variante au panier puis ouvre le tiroir (window.__ycooAddToCart, layout/theme.liquid)
  window.__ycooAddVariant = function(variantId) {
    return window.__ycooAddToCart(variantId, true);
  };

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.product-card__size-btn');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;

    window.__ycooAddVariant(variantId)
    .then(function() {
      btn.classList.add('product-card__size-btn--added');
      setTimeout(function() {
        btn.disabled = false;
        btn.classList.remove('product-card__size-btn--added');
      }, 1500);
    })
    .catch(function() {
      btn.disabled = false;
    });
  }, true);

  // Panneau des tailles (écran tactile) : rempli avec les tailles de la couleur affichée sur la carte
  var sizeSheet = null;

  function closeSizeSheet() {
    if (!sizeSheet) return;
    sizeSheet.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  function getSizeSheet() {
    if (sizeSheet) return sizeSheet;
    sizeSheet = document.createElement('div');
    sizeSheet.className = 'ycoo-size-sheet';
    sizeSheet.innerHTML =
      '<div class="ycoo-size-sheet__overlay"></div>' +
      '<div class="ycoo-size-sheet__panel" role="dialog" aria-modal="true" aria-label="' + t.size + '">' +
        '<button type="button" class="ycoo-size-sheet__close" aria-label="' + t.close + '">' +
          '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><path d="M1 1l14 14M15 1L1 15"/></svg>' +
        '</button>' +
        '<p class="ycoo-size-sheet__title">' + t.size + '</p>' +
        '<div class="ycoo-size-sheet__list"></div>' +
        '<a class="ycoo-size-sheet__guide" hidden>' + t.sizeGuide + '</a>' +
      '</div>';
    document.body.appendChild(sizeSheet);

    sizeSheet.addEventListener('click', function(e) {
      if (e.target.closest('.ycoo-size-sheet__close') || e.target.classList.contains('ycoo-size-sheet__overlay')) {
        closeSizeSheet();
        return;
      }

      var size = e.target.closest('.ycoo-size-sheet__size');
      if (!size || size.disabled) return;

      var sizes = sizeSheet.querySelectorAll('.ycoo-size-sheet__size');
      sizes.forEach(function(b) { b.disabled = true; });
      window.__ycooAddVariant(size.dataset.variantId)
        .then(closeSizeSheet)
        .catch(function() {
          sizes.forEach(function(b) { b.disabled = b.hasAttribute('data-sold-out'); });
        });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeSizeSheet();
    });

    return sizeSheet;
  }

  document.addEventListener('click', function(e) {
    var opener = e.target.closest('.product-card__size-open');
    if (!opener) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var card = opener.closest('.product-card');
    var row = card && card.querySelector('.product-card__size-row:not([hidden])');
    if (!row) return;

    var sheet = getSizeSheet();
    var list = sheet.querySelector('.ycoo-size-sheet__list');
    list.innerHTML = '';
    row.querySelectorAll('.product-card__size-btn').forEach(function(src) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ycoo-size-sheet__size';
      b.dataset.variantId = src.dataset.variantId;
      b.textContent = src.textContent.trim();
      if (src.classList.contains('product-card__size-btn--sold-out')) {
        b.disabled = true;
        b.setAttribute('data-sold-out', '');
      }
      list.appendChild(b);
    });

    var guide = sheet.querySelector('.ycoo-size-sheet__guide');
    if (opener.dataset.sizeGuide) {
      guide.href = opener.dataset.sizeGuide;
      guide.hidden = false;
    } else {
      guide.hidden = true;
    }

    document.documentElement.style.overflow = 'hidden';
    sheet.offsetWidth;
    sheet.classList.add('is-open');
  }, true);

  // Précharge les photos du diaporama d’une carte (couleur affichée uniquement) au premier survol
  // ou au premier focus de cette carte : les flèches affichent ensuite la photo suivante sans attendre.
  // Sur mobile, les photos du défilement se chargent d’elles-mêmes à l’approche (loading="lazy").
  window.__ycooPreload = function(root) {
    (root && root.querySelectorAll ? root : document).querySelectorAll('.ycoo-slide:not(.is-other-color):not([data-preloaded])').forEach(function(s) {
      s.setAttribute('data-preloaded', '');
      (new Image()).src = s.getAttribute('src');
    });
  };

  function preloadCard(e) {
    var card = e.target.closest && e.target.closest('.product-card');
    if (!card || card.hasAttribute('data-slides-preloaded')) return;
    card.setAttribute('data-slides-preloaded', '');
    window.__ycooPreload(card);
  }

  document.addEventListener('pointerover', function(e) {
    if (e.pointerType === 'mouse') preloadCard(e);
  });
  document.addEventListener('focusin', preloadCard);
})();
